export enum saleRecordPaymentType {
    Debit = 0,
    Credit = 1
}